import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";
import {KindOfOrder} from "../../../../types/enums";

export async function apiDeleteFileAttachment(documentID: number, kindOfOrder: KindOfOrder): Promise<ApiResult> {
    try {
        return await apiClient.delete("document", { params: { documentID: documentID, kindOfOrder: kindOfOrder } });
    }
    catch (error) {
        return {
            isSuccess: false,
            errorMessage: "Error when deleting the file: " + error
        };
    }
}
